export default {
  state: {
    people: '',
  },
  getters: {
    getCount: (state) => {
      return state.people;
    },
  },
  mutations: {
    SET_PEOPLE(state, payload) {
      state.people = payload;
    },
  },
  actions: {
    setPeople({ commit }, payload) {
      commit('SET_PEOPLE', payload);
      localStorage.setItem('count', payload);
    },
    async resetCount({ commit }) {
      commit('SET_PEOPLE', '');
      localStorage.removeItem('count');
    },
  },
}